// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"f548a037","213":"764a834e","732":"579c37d0"}[chunkId] + ".chunk.js";
};